import { render, staticRenderFns } from "./SectionContacts.vue?vue&type=template&id=72b667e5&scoped=true"
import script from "./SectionContacts.vue?vue&type=script&lang=js"
export * from "./SectionContacts.vue?vue&type=script&lang=js"
import style0 from "./SectionContacts.vue?vue&type=style&index=0&id=72b667e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b667e5",
  null
  
)

export default component.exports